import React, { useCallback, useEffect, useState } from 'react'
import Loader from '../../Loader/Loader';
import QueriesTable from './QueriesTable/QueriesTable';
import { getQueriesAPI } from '../../utils/APIs/queriesApis';

const Queries = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
      const [roleData, setRoleData] = useState([]);
    
      useEffect(() => {
        const interval = setInterval(() => {
          const stored = sessionStorage.getItem("isSidebarOpen");
          const parsed = stored !== null ? JSON.parse(stored) : true;
    
          if (parsed !== isSidebarOpen) {
            setIsSidebarOpen(parsed);
          }
        }, 10);
    
        return () => clearInterval(interval);
      }, [isSidebarOpen]);
      
 const [page, setPage] = useState(() => {
     const savedPage = sessionStorage.getItem("queriesPage");
     return savedPage ? Number(savedPage) : 1;
   });
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const LIMIT = 10;

  const fetchData = useCallback(async (pageNo = page) => {
    setLoading(true);
    try {
      const res = await getQueriesAPI(pageNo, LIMIT);

      setRoleData(res?.data?.data || []);
      setTotal(res?.data?.meta?.total || 0);
      setPage(res?.data?.meta?.page || pageNo);
    } catch (err) {
      console.error("failed to fetch queries", err);
    } finally {
      setLoading(false);
    }
 }, [page]);

  useEffect(() => {
  fetchData(page);
}, [fetchData, page]);

  const totalPages = Math.ceil(total / LIMIT);

  const getPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  };

  if (loading) {
    return <Loader />
  }


  return (
    <div
      className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"
        }`}
      style={{ marginTop: "100px" }}
    >
      <div className="my-quote-page page-inner-wrapper">
        <h2 className="page-title">Queries</h2>
      

      <div className="role-header">
        {/* <button className="btn-add-role" onClick={() => setShowModal(true)}>
          + Add Role
        </button> */}
      </div>

      <QueriesTable
        data={roleData}
        page={page}
        limit={LIMIT}
        refreshData={() => fetchData(page)}
      />

      {totalPages > 1 && (
        <div className="pagination">
          {/* Prev */}
          <button
            className="pagination-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          {/* Page Numbers */}
          {getPageNumbers().map((p) => (
            <button
              key={p}
              className={`pagination-btn ${p === page ? "active" : ""}`}
              onClick={() => setPage(p)}
            >
              {p}
            </button>
          ))}

          {/* Next */}
          <button
            className="pagination-btn"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}

      </div>
    </div>
  );
};

export default Queries;
